import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingGate } from "./OnboardingGate";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-[60vh] w-full max-w-full items-center justify-center px-4">
        <div className="flex max-w-md flex-col items-center text-center animate-in fade-in duration-300">
          <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-purple-100 border-t-purple-600 mb-4" />
          <span className="text-sm font-semibold text-slate-600 tracking-wide animate-pulse">
            Carregando sessão...
          </span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  return <OnboardingGate>{children}</OnboardingGate>;
}

